<template>
  <canvas ref="canvas" />
</template>

<script>
import { DotLottie } from "@lottiefiles/dotlottie-web";

export default {
  name: "EgLottiePlayer",

  props: {
    src: {
      type: String,
      required: true,
    },
    loop: {
      type: Boolean,
      default: true,
    },
    autoplay: {
      type: Boolean,
      default: true,
    },
  },

  mounted() {
    this.initLottie();
  },

  methods: {
    initLottie() {
      this.lottie = new DotLottie({
        autoplay: this.autoplay,
        loop: this.loop,
        canvas: this.$refs.canvas,
        src: this.src,
      });
    },
  },
};
</script>
